import React from 'react';
import '../../styles.css';

export default function Input(props) {
    return (
        <input
            type="text"
            placeholder={props.placeholder}
            className="tw:formkit-input tw:bg-gray-50 tw:border tw:border-gray-300 tw:text-gray-900 tw:text-sm tw:rounded-lg tw:focus:ring-blue-500 tw:focus:border-blue-500 tw:block tw:w-full tw:p-2.5 tw:dark:bg-gray-700 tw:dark:border-gray-600 tw:dark:placeholder-gray-400 tw:dark:text-white tw:dark:focus:ring-blue-500 tw:dark:focus:border-blue-500"
        />
    )
};